// extracted by mini-css-extract-plugin
export default {"message-group":"dfwxg","message-group__date":"vdnJx"};